var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bimEditorJS',{attrs:{"value":_vm.value,"formKey":"value","formModel":_vm._self,"imgUploadURL":_vm.imgUploadURL,"customComponents":_vm.customComponents},on:{"input":function (v) { return _vm.$emit('input', v); }}})}
var staticRenderFns = []

export { render, staticRenderFns }